import { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { SeletorDeSistemas } from "./SeletorDeSistemas";

interface MainLayoutProps {
  children: ReactNode;
  userType: "admin" | "aluno";
  userName: string;
  userPhoto?: string;
  userSexo?: "Masculino" | "Feminino" | "Prefiro não dizer";
}

export const MainLayout = ({ children, userType }: MainLayoutProps) => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen w-full bg-background">
      {/* Desktop Sidebar (visible on md screens and larger) */}
      <div className="hidden md:block md:w-64 md:flex-shrink-0 md:sticky md:top-0 md:h-screen md:overflow-y-auto bg-[#013079]">
        <Sidebar userType={userType} />
      </div>

      {/* Mobile Top Header (visible on screens smaller than md) */}
      <header className="md:hidden flex items-center justify-between p-4 bg-[#013079] text-white shadow-md">
        <div className="flex items-center gap-3">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="text-white hover:bg-white/10 h-10 w-10">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="p-0 bg-[#013079] text-white w-64 border-r-0">
              <Sidebar userType={userType} />
            </SheetContent>
          </Sheet>
          <span className="font-bold text-lg tracking-wide">Memoire</span>
        </div>
        <div className="flex items-center gap-2">
          <SeletorDeSistemas />
          <span className="text-xs font-semibold bg-white/20 px-2.5 py-1 rounded-full uppercase">
            {userType === "admin" ? "Admin" : "Aluno"}
          </span>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 overflow-x-hidden">
        <div className="container mx-auto p-4 md:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};
